import React from 'react';
import { ExportSubTitle, ExportTitleWrapper } from '../styled';

export const ExportTitle = () => {
  return (
    <ExportTitleWrapper>
      Export Options
      <ExportSubTitle>Select from the list below to export</ExportSubTitle>
    </ExportTitleWrapper>
  );
};
